import script from "./SwitchComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchComponent.vue?vue&type=script&setup=true&lang=js"

import "./SwitchComponent.vue?vue&type=style&index=0&id=370f8175&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-370f8175"]])

export default __exports__